const getPieceConfiguration = item => item.pieceConfiguration || item.piece_configuration || {};

const getSelectedFinishes = item => {
  const finishes = item.finishes ?? getPieceConfiguration(item).finishes;
  return Array.isArray(finishes) ? finishes : [];
};

export const hasMaterialIncludedLaminate = breakdown =>
  breakdown?.laminate_enabled === true ||
  breakdown?.materials?.some(material => material.pricing_method === 'mounted_board_laminate') === true;

export const getLargeFormatLaminateLabel = item => {
  const piece = getPieceConfiguration(item);
  const options = {
    ...piece.finishing_options,
    ...piece.finishingOptions,
    ...item.finishing_options,
    ...item.finishingOptions,
  };
  const material = options.laminate?.material;
  const savedLabel = item.processes?.find(name => /laminat/i.test(name) &&
    !/^laminate(?: \(single-sided\))?$/i.test(name));
  if (!material && savedLabel) return savedLabel;
  return material ? `Laminate — ${material} (single-sided)` : 'Laminate (single-sided)';
};

// Cost rows can omit operations charged under materials (mounted-board laminate).
// Keep their enriched labels, but reconcile them with the actual selection.
export const getLargeFormatProcessNames = (item, finishingProcesses = []) => {
  const breakdown = item.breakdown || {};
  const costProcesses = Array.isArray(breakdown.finishing_processes) ? breakdown.finishing_processes : [];
  const savedNames = Array.isArray(item.processes) ? item.processes.filter(name => typeof name === 'string') : [];
  // Legacy saved processes are labels, not IDs. Match their base labels while
  // retaining option suffixes such as "Velcro - 2 short edges".
  const processKey = name => (name || '').split(/\s+[—–-]\s+|\s*\(/)[0]
    .toLowerCase().replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
  const names = costProcesses.filter(process => process.name).map(process => {
    const saved = savedNames.find(name => processKey(name) === processKey(process.name) ||
      processKey(name) === processKey(process.id));
    return saved && saved.length > process.name.length ? saved : process.name;
  });
  savedNames.forEach(name => {
    if (!names.some(existing => processKey(existing) === processKey(name))) names.push(name);
  });
  const selected = getSelectedFinishes(item);

  selected.forEach(id => {
    if (id === 'laminate') return;
    const process = costProcesses.find(process => process.id === id) ||
      finishingProcesses.find(process => process.id === id);
    const name = process?.name || id;
    if (names.some(existing => processKey(existing) === processKey(name) ||
      processKey(existing) === processKey(id))) return;
    // Without a catalogue/cost row we cannot reliably associate an opaque ID
    // with a saved human-readable label. Preserve the saved instructions.
    if (!process && savedNames.length > 0) return;
    names.push(name);
  });

  if (selected.includes('laminate') || hasMaterialIncludedLaminate(breakdown)) {
    const index = names.findIndex(name => /laminat/i.test(name));
    if (index === -1) {
      names.push(getLargeFormatLaminateLabel(item));
    } else if (/^laminate(?: \(single-sided\))?$/i.test(names[index])) {
      names[index] = getLargeFormatLaminateLabel(item);
    }
  }
  return names;
};
